import { useEffect, useState } from 'react';
import { APP_STORE_URLS } from '../../constants/appStores';
import styles from './RedirectToApp.module.scss';

const detectPlatform = () => {
  const ua = navigator.userAgent || '';
  const platform = navigator.userAgentData?.platform || navigator.platform || '';
  const maxTouch = navigator.maxTouchPoints || 0;
  const isCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
  const isStandalone = 'standalone' in navigator;

  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (/Mac/.test(platform) && maxTouch > 1) ||
    (/Mac/.test(platform) && isCoarsePointer && isStandalone);

  const isAndroid =
    /android/i.test(ua) ||
    (/Linux/.test(platform) && maxTouch > 1 && isCoarsePointer);

  const isHarmony = /HarmonyOS/i.test(ua);

  const isMobile = isIOS || isAndroid || isHarmony ||
    /webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);

  return { isIOS, isAndroid, isHarmony, isMobile };
};

const RedirectToApp = () => {
  const [status, setStatus] = useState('redirecting');

  useEffect(() => {
    const { isIOS, isAndroid, isMobile } = detectPlatform();

    const params = new URLSearchParams(window.location.search);
    const encodedDeepLink = params.get('link');
    const fallbackURL = params.get('fallback');

    if (!encodedDeepLink) {
      if (isAndroid) {
        setStatus('store-android');
        window.location.href = APP_STORE_URLS.ANDROID;
        return;
      }
      if (isIOS) {
        setStatus('store-ios');
        window.location.href = APP_STORE_URLS.IOS;
        return;
      }

      setStatus('desktop');
      setTimeout(() => {
        window.location.href = '/';
      }, 1500);
      return;
    }

    if (!isMobile) {
      setStatus('desktop');
      setTimeout(() => {
        window.location.href = fallbackURL || '/';
      }, 1500);
      return;
    }

    const deepLink = decodeURIComponent(encodedDeepLink);
    window.location.assign(deepLink);

    const timeout = setTimeout(() => {
      const isPageVisible = document.visibilityState === 'visible';
      if (isPageVisible) {
        setStatus('app-not-found');
        setTimeout(() => {
          window.location.assign(fallbackURL || '/');
        }, 2000);
      }
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  const getContent = () => {
    switch (status) {
      case 'redirecting':
        return {
          icon: '📱',
          title: 'Opening TigSiPay',
          subtitle: 'Please wait while we redirect you to the app...'
        };
      case 'desktop':
        return {
          icon: '💻',
          title: 'Desktop Detected',
          subtitle: 'Redirecting you to the website...'
        };
      case 'app-not-found':
        return {
          icon: '🔍',
          title: 'App Not Found',
          subtitle: 'Redirecting you to the website...'
        };
      case 'store-android':
        return {
          icon: '🤖',
          title: 'Opening Google Play',
          subtitle: 'Redirecting you to the TigSiPay app...'
        };
      case 'store-ios':
        return {
          icon: '🍎',
          title: 'Opening App Store',
          subtitle: 'Redirecting you to the TigSiPay app...'
        };
      case 'no-link':
        return {
          icon: '🔗',
          title: 'Invalid Link',
          subtitle: 'Redirecting you to the homepage...'
        };
      default:
        return {
          icon: '⏳',
          title: 'Please Wait',
          subtitle: 'Processing your request...'
        };
    }
  };

  const content = getContent();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.iconWrapper}>
          <span className={styles.icon}>{content.icon}</span>
        </div>

        <h1 className={styles.title}>{content.title}</h1>
        <p className={styles.subtitle}>{content.subtitle}</p>

        <div className={styles.loader}>
          <div className={styles.loaderBar}></div>
        </div>

        <div className={styles.logo}>
          <span className={styles.logoText}>TigSiPay</span>
        </div>
      </div>
    </div>
  );
};

export default RedirectToApp;